import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=34dc9b92&scoped=true&"
import script from "./AboutPage.vue?vue&type=script&lang=js&"
export * from "./AboutPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=34dc9b92&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dc9b92",
  null
  
)

export default component.exports